import {isNil} from 'ramda';

import i18n from '@dms/i18n';

import {NullishBoolean} from 'shared/web';

export const getVehicleAdvertisementTypeFlagProps = (inSale: NullishBoolean) => {
  if (isNil(inSale)) {
    return null;
  }

  return inSale
    ? ({
        colorScheme: 'green',
        label: i18n.t('entity.vehicle.labels.publishingStateTrue'),
      } as const)
    : ({
        colorScheme: 'orange',
        label: i18n.t('entity.vehicle.labels.publishingStateFalse'),
      } as const);
};
